module.exports = __webpack_public_path__ + "img/science-4-en.d8493f36.png";